import React from 'react';

import { NextEditorPlugin } from '@atlaskit/editor-common/types';
import { ToolbarButton } from '@atlaskit/editor-common/ui-menu';

import { CodeSuggestionsIcon } from './CodeSuggestionsIcon';

export const codeSuggestionsPlugin: NextEditorPlugin<'codeSuggestions'> = ({
  api,
}) => {
  return {
    name: 'codeSuggestions',
    primaryToolbarComponent: () => {
      return (
        <ToolbarButton
          title="Code Suggestions"
          onClick={() => {
            api?.core.actions.execute(({ tr }) => {
              const node = tr.doc.type.schema.nodes.extension.createChecked({
                extensionType: 'com.atlassian.bbc.code-suggestions',
                extensionKey: 'codesuggestions:node-code-suggest-editing-mode',
              });
              return tr.insert(tr.selection.from, node);
            });
          }}
          iconBefore={<CodeSuggestionsIcon />}
        />
      );
    },
  };
};
